"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'DownloadBillDialog',
  data: function data() {
    return {
      dialogVisible: false,
      billInfo: {
        merchantType: '核销商家',
        merchantName: '家家乐',
        periodStart: '2025-05-01 00:00:00',
        periodEnd: '2025-05-31 23:59:59'
      },
      pageForm: {
        page: 1,
        limit: 20
      },
      // 导出状态：0=导出中，1=导出成功，2=导出失败
      EXPORT_STATUS_MAP: {
        0: '导出中',
        1: '导出成功',
        2: '导出失败'
      },
      // 静态 mock 数据
      tableData: {
        total: 20,
        list: [{
          operator: '张三',
          exportTime: '2026-05-18 21:04:15',
          completeTime: '2026-05-18 21:04:15',
          fileName: '对账单_家家乐_2025-05-01至2025-05-31.xlsx',
          exportStatus: 0
        }, {
          operator: '张三',
          exportTime: '2026-05-18 21:04:15',
          completeTime: '2026-05-18 21:04:15',
          fileName: '对账单_家家乐_2025-05-01至2025-05-31.xlsx',
          exportStatus: 1
        }, {
          operator: '张三',
          exportTime: '2026-05-18 21:04:15',
          completeTime: '2026-05-18 21:04:15',
          fileName: '对账单_家家乐_2025-05-01至2025-05-31.xlsx',
          exportStatus: 2
        }]
      }
    };
  },
  methods: {
    open: function open(row) {
      if (row) {
        this.billInfo.merchantName = row.merchantName || '家家乐';
        this.billInfo.merchantType = row.merchantType || '核销商家';
        this.billInfo.periodStart = row.periodStart || '2025-05-01 00:00:00';
        this.billInfo.periodEnd = row.periodEnd || '2025-05-31 23:59:59';
      }
      this.dialogVisible = true;
    },
    exportStatusClass: function exportStatusClass(status) {
      if (status === 0) return 'status-exporting';
      if (status === 1) return 'status-success';
      if (status === 2) return 'status-fail';
      return '';
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageForm.limit = val;
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.pageForm.page = val;
    }
  }
};